import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

const statusStamp = {
  "Being Held": "Being held",
  "Still Being Held": "Still being held",
  "Answer Acknowledged": "Answer acknowledged",
  "Answered Differently": "Answered differently",
  "No Longer Requested": "No longer requested",
  "Withdrawn With Gratitude": "Withdrawn with gratitude",
};

export default function MyPrayerList() {
  const [prayers, setPrayers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/me/prayer-list").then(({ data }) => setPrayers(data.prayers)).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const remove = async (id) => {
    await api.delete(`/me/hold/${id}`);
    setPrayers((p) => p.filter((x) => x.id !== id));
    toast("Quietly removed. There is no need to explain.");
  };

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-10 py-20">
      <p className="mono-label mb-4">My Prayer List</p>
      <h1 className="font-heading text-4xl md:text-5xl text-ink leading-none">The prayers you carry</h1>
      <p className="font-body text-lg text-ink-secondary mt-6 leading-relaxed">
        A small number, held faithfully, is worth more than a long list. You may remove any prayer quietly, at any time.
      </p>

      <div className="flex gap-4 mt-8">
        <Link to="/morning" className="btn-ink" data-testid="mylist-morning">Morning Prayer</Link>
        <Link to="/evening" className="btn-ink" data-testid="mylist-evening">Evening Prayer</Link>
      </div>

      {loading ? (
        <p className="mono-label mt-16">Attending…</p>
      ) : prayers.length === 0 ? (
        <div className="mt-16 border border-ink/15 p-12 text-center">
          <p className="font-body text-lg text-ink-secondary italic">You are not holding any prayers yet.</p>
          <Link to="/vigil" className="btn-solid mt-8 inline-block" data-testid="mylist-visit-vigil">Enter the Vigil</Link>
        </div>
      ) : (
        <div className="mt-14 space-y-px bg-ink/15 border border-ink/15">
          {prayers.map((p) => (
            <div key={p.id} className="bg-paper p-8" data-testid={`mylist-${p.id}`}>
              <div className="flex items-baseline justify-between gap-4 mb-3">
                <span className="mono-label">Added {new Date(p.date_added).toLocaleDateString()}</span>
                <span className="stamp">{statusStamp[p.status] || p.status}</span>
              </div>
              <h3 className="font-heading text-2xl text-ink">{p.display_name}</h3>
              <p className="font-body text-ink-secondary mt-2 leading-relaxed">{p.excerpt}</p>
              {p.latest_update && (
                <p className="font-body text-ink mt-3 border-l-2 border-sage pl-4 italic">Latest: {p.latest_update}</p>
              )}
              <button onClick={() => remove(p.id)} className="mono-label mt-5 underline underline-offset-4 hover:text-ink" data-testid={`mylist-remove-${p.id}`}>
                Withdraw with gratitude
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
